import { Action, createReducer, on } from '@ngrx/store';

import { DataObject } from '../models/core.models';

import {
  selectObjects,
  clearSelectedObjects,
  toggleObjectSelected,
} from '../actions/selected.actons';
import {
  objectChanged,
  massObjectOperationSuccess,
} from '../actions/core.actions';
import { deleteWidgetsSuccess } from '../actions/widget.actions';

import { produce } from 'immer';

export interface SelectedObjectsState {
  selectedObjects: Map<string, DataObject>;
}

export const initialState: SelectedObjectsState = {
  selectedObjects: new Map<string, DataObject>(),
};

const _selectedObjectsReducer = createReducer(
  initialState,

  on(
    toggleObjectSelected,
    produce((draft, { object }) => {
      if (draft.selectedObjects.has(object.id)) {
        draft.selectedObjects.delete(object.id);
      } else {
        draft.selectedObjects.set(object.id, object);
      }
    }),
  ),

  on(
    clearSelectedObjects,
    produce((draft) => {
      draft.selectedObjects = new Map<string, DataObject>();
    }),
  ),

  // ! triggered from DashBoard "Select All"
  on(
    selectObjects,
    produce((draft, { objects }) => {
      if (!objects || objects.length === 0) {
        return;
      }

      draft.selectedObjects = new Map<string, DataObject>();

      for (const object of objects) {
        if (object.can_edit === false) {
          continue;
        }
        draft.selectedObjects.set(object.id, object);
      }
    }),
  ),

  on(
    objectChanged,
    produce((draft) => {
      draft.selectedObjects = new Map<string, DataObject>();
    }),
  ),

  on(
    deleteWidgetsSuccess,
    produce((draft, { widgetIds }) => {
      for (const id of widgetIds) {
        draft.selectedObjects.delete(id);
      }
    }),
  ),

  on(
    massObjectOperationSuccess,
    produce((draft, { response }) => {
      if (response.operation === 'delete') {
        const fields = ['dashboards', 'dimensions', 'feeds', 'workspaces'];

        for (const field of fields) {
          for (const object of response.data[field]) {
            draft.selectedObjects.delete(object.id);
          }
        }
      }
    }),
  ),
);

export function selectedObjectsReducer(
  state: SelectedObjectsState,
  action: Action,
) {
  return _selectedObjectsReducer(state, action);
}
